import { Pipe, PipeTransform } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { Rental, selectRentalById } from '../stores'

@Pipe({
  name: 'rentalById',
  standalone: false,
})
export class RentalByIdPipe implements PipeTransform {
  constructor(private store: Store<any>) {}

  transform(rentalId: string): Observable<Rental> {
    return this.store.pipe(select(selectRentalById(rentalId)))
  }
}
